// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__yyORl","additionalInfo":"AgreementModal_additionalInfo__20yRP"};